import {
  CreateFulfillmentOrderSchema,
  type ICreateFulfillmentOrder,
} from "@redotech/redo-fulfillment-operations-common/create-fulfillment-order";
import * as z from "zod";

export const editManualFulfillmentGroups = {
  name: "editManualFulfillmentGroups" as const,
  input: z.object({
    fulfillmentGroupEdits: z.array(
      z.object({
        fulfillmentGroupId: z.string(),
        data: CreateFulfillmentOrderSchema as ICreateFulfillmentOrder,
      }),
    ),
  }),
  output: z.object({ success: z.boolean() }),
};
